import * as actionTypes from "../actionTypes";

export function setConfigDataSegment(configDataSegment) {
  return { type: actionTypes.SET_CONFIGDATASEGMENT, data: configDataSegment };
}

export function clearConfigDataSegment() {
  return { type: actionTypes.CLEAR_CONFIGDATASEGMENT };
}

export function setDataSegment(dataSegment) {
  return { type: actionTypes.SET_DATASEGMENT, data: dataSegment };
}

export function updateDataSegment(updateData) {
  return { type: actionTypes.UPDATE_DATASEGMENT, data: updateData };
}

export function clearDataSegment() {
  return { type: actionTypes.CLEAR_DATASEGMENT };
}

